import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import LedgerLayer from "../../components/Accounts/LedgerLayer";

const LedgerPage = () => {
  return (
    <MasterLayout>
      <LedgerLayer />
    </MasterLayout>
  );
};

export default LedgerPage;
